export default "__VITE_ASSET__DEnHprX2__";